import React from "react";
import { FiCheckCircle, FiLock, FiRefreshCcw, FiShield, FiUploadCloud } from "react-icons/fi";
import { IoMdQrScanner } from "react-icons/io";
import { MdOutlineDashboard } from "react-icons/md";
import "./UserHowItWorks.css";

const guideSteps = [
  {
    icon: FiCheckCircle,
    title: "Step 1: Generate Your QR",
    text: "Open Generator from the sidebar and create your personal QR code. Download it after generation.",
  },
  {
    icon: FiUploadCloud,
    title: "Step 2: Add Content",
    text: "Go to Create Content. Upload your file or text and link it to the QR. You can categorize and label each upload.",
  },
  {
    icon: FiRefreshCcw,
    title: "Step 3: Choose Content Type",
    text: "Use Permanent content for always-on links. Use Temporary content when you want content to expire after a selected duration.",
  },
  {
    icon: FiLock,
    title: "Step 4: Protect With PIN",
    text: "Enable Secure Content and set a PIN. Viewers must enter this PIN before opening protected content.",
  },
  {
    icon: IoMdQrScanner,
    title: "Step 5: Share and Let People Scan",
    text: "Print or share your QR. When someone scans, the content opens through Current Content. For public scans with ?un=, only content view is shown.",
  },
  {
    icon: MdOutlineDashboard,
    title: "Step 6: Track Performance",
    text: "Use Home (Dashboard) to monitor your QR activity, manage existing content, and set your active default content.",
  },
];

const quickTips = [
  "Use clear labels so you can identify content quickly in Dashboard.",
  "Use temporary mode for campaigns, events, or time-limited drops.",
  "Keep secure PIN content for private memories and premium access.",
  "Set one content as active to control what scanners see first.",
];

const UserHowItWorks = () => {
  return (
    <section className="user-guide">
      <div className="user-guide-header">
        <h3>How It Works</h3>
        <p>
          Follow this workflow to create a QR, attach content, control access,
          and track usage in one place.
        </p>
      </div>

      <div className="user-guide-grid">
        {guideSteps.map((step) => {
          const Icon = step.icon;
          return (
            <article key={step.title} className="user-guide-card">
              <span className="user-guide-icon">
                <Icon />
              </span>
              <h4>{step.title}</h4>
              <p>{step.text}</p>
            </article>
          );
        })}
      </div>

      <div className="user-guide-footer">
        <h4>
          <FiShield />
          Pro Tips
        </h4>
        <ul>
          {quickTips.map((tip) => (
            <li key={tip}>{tip}</li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default UserHowItWorks;
